import { useEffect, useState } from "react";

/* ===== DATA ===== */
const CARDS = [
  { bg: "#6b6b6b" },
  { bg: "#c7d1c6" },
  { bg: "#d6c9b8" },
  { bg: "#bfc4c9" },
  { bg: "#c9bfb3" },
];

const IMAGES = [
  "/fram1.png",
  "/fram2.png",
  "/fram3.png",
  "/fram4.png",
  "/fram5.png",
];

export default function MiniPortfolio() {
  const [index, setIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const minSwipeDistance = 50;

  const front = CARDS[index % CARDS.length];
  const back = CARDS[(index + 1) % CARDS.length];

  const frontImg = IMAGES[index % IMAGES.length];
  const backImg = IMAGES[(index + 1) % IMAGES.length];

  const next = () =>
    setIndex((i) => (i + 1) % CARDS.length);

  const prev = () =>
    setIndex((i) => (i - 1 + CARDS.length) % CARDS.length);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % CARDS.length);
    }, 2300);
    return () => clearInterval(id);
  }, []);

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;

    if (distance > minSwipeDistance) next();
    if (distance < -minSwipeDistance) prev();
  };

  return (
    <section
  className="
    w-full
    bg-[#f6f3ee]

    max-h-[65vh]       /* smaller on mobile */

    md:max-h-[65vh]    /* medium screens */

    lg:h-[60vh]    /* bigger on laptop */

    overflow-hidden

    pt-[0.5vh]
    pb-[1vh]
    md:pt-[1vh]
    md:pb-[0.5vh]
  "
  style={{
    paddingLeft: "4vw",
    paddingRight: "4vw",
  }}
>


      <div className="relative mx-auto w-full -mt-6 md:mt-0 lg:-mt-6 top-16 md:top-0 lg:pt-[4vh]">


        <div
          className="
            grid
            grid-cols-1
            lg:grid-cols-[1fr_1.25fr]
            overflow-hidden
            md:overflow-visible
            gap-y-0
            md:gap-y-8
            lg:gap-y-0
          "
          style={{ columnGap: "8vw" }}
        >
          {/* TEXT */}
          <div className="relative z-20 bg-[#f6f3ee]">
            <h2
              style={{
                fontFamily: "'PP Neue Montreal', sans-serif",
                fontWeight: 400,
                fontSize: "clamp(36px, 4.5vw, 60px)",
                lineHeight: "1.18",
                letterSpacing: "0.05em",
                color: "#0f0f0f",
              }}
            >
              <span style={{ display: "block" }}>Design That</span>
              <span style={{ display: "block" }}>Speaks Before</span>
              <span style={{ display: "block" }}>Logos Do</span>
            </h2>

            <p
              className="mb-1 md:mb-0"
              style={{
                fontSize: "clamp(14px, 1.1vw, 16px)",
                lineHeight: "1.7",
                color: "#666",
                maxWidth: "440px",
              }}
            >
              A glimpse into how we translate brand identity into apparel across
              industries and use-cases.
            </p>
          </div>

          {/* CARD STACK */}
          <div
            className="relative mx-auto w-full mt-[-8vh] md:mt-0"
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
          >
            <div
              className="relative"
              style={{
                minHeight: "clamp(360px, 57vh, 620px)",
                maxWidth: "clamp(320px, 65vw, 900px)",
                margin: "0 auto",
              }}
            >
              {/* BACK CARD */}
              <div
                className="absolute top-0 transition-all duration-700"
                style={{
                  left: "clamp(50%, 60%, 62%)",
                  width: "clamp(45%, 48%, 52%)",
                  height: "82%",
                  background: back.bg,
                }}
              >
                <img
                  src={backImg}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    padding: "clamp(12px, 4%, 28px)",
                    background: "#f6f3ee",
                  }}
                />
              </div>

              {/* FRONT CARD */}
              <div
                className="absolute top-0 left-0 z-10 transition-all duration-700"
                style={{
                  width: "clamp(60%, 65%, 70%)",
                  height: "100%",
                  background: front.bg,
                }}
              >
                <img
                  src={frontImg}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    padding: "clamp(12px, 4%, 28px)",
                    background: "#f6f3ee",
                  }}
                />
              </div>
            </div>

            {/* DOT INDICATORS */}
            {/* <div className="flex justify-center mt-1 sm:mt-8 lg:mt-7 gap-3">
              {CARDS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIndex(i)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    i === index
                      ? "bg-black scale-125"
                      : "bg-gray-400 hover:bg-gray-600"
                  }`}
                />
              ))}
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}
